import { Fragment, ReactElement, memo } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import FormFilter from './form';
import * as yup from 'yup';
import { fiscalCodeRegex } from 'shell/constants/regex';
import { ResearchPerson } from 'civil-status/view-models/research-category-form';

export const validationSchemaResearchPerson = yup
  .object({
    fiscalCode: yup
      .string()
      .notRequired()
      .matches(fiscalCodeRegex, 'Il campo deve essere un codice fiscale'),
    surname: yup.string().nullable(),
    name: yup.string().nullable(),
    birthDate: yup.date().nullable().typeError('Data non valida'),
    idAnpr: yup.string().nullable(),
    idAnsc: yup.string().nullable(),
    state: yup.object({}),
    municipality: yup.object({}),
  })
  // tipo di ricerca 2
  .test('surname', 'Campo obbligatorio', (values) => {
    const valuesCasted = (values || {}) as unknown as ResearchPerson;

    if (
      !valuesCasted.surname &&
      (valuesCasted.gender ||
        valuesCasted.municipality?.description ||
        valuesCasted.state?.value ||
        valuesCasted.name ||
        valuesCasted.birthDate)
    ) {
      return new yup.ValidationError('Campo obbligatorio', undefined, 'surname');
    }

    return true;
  })
  .test('name', 'Campo obbligatorio', (values) => {
    const valuesCasted = (values || {}) as unknown as ResearchPerson;

    if (
      !valuesCasted.name &&
      (valuesCasted.gender ||
        valuesCasted.municipality?.description ||
        valuesCasted.state?.value ||
        valuesCasted.surname ||
        valuesCasted.birthDate)
    ) {
      return new yup.ValidationError('Campo obbligatorio', undefined, 'name');
    }

    return true;
  })
  .test('gender', 'Campo obbligatorio', (values) => {
    const valuesCasted = (values || {}) as unknown as ResearchPerson;

    if (
      !valuesCasted.gender &&
      (valuesCasted.name ||
        valuesCasted.municipality?.description ||
        valuesCasted.state?.value ||
        valuesCasted.surname ||
        valuesCasted.birthDate)
    ) {
      return new yup.ValidationError('Campo obbligatorio', undefined, 'gender');
    }

    return true;
  })
  .test('birthDate', 'Campo obbligatorio', (values) => {
    const valuesCasted = (values || {}) as unknown as ResearchPerson;

    if (!valuesCasted.birthDate && (valuesCasted.name || valuesCasted.surname)) {
      return new yup.ValidationError('Campo obbligatorio', undefined, 'birthDate');
    }

    return true;
  })
  // tipo di ricerca 5
  .test('state', 'Campo obbligatorio', (values) => {
    const valuesCasted = (values || {}) as unknown as ResearchPerson;

    if (!valuesCasted.isEvent && valuesCasted.isForeign && !valuesCasted.state?.id) {
      return new yup.ValidationError('Campo obbligatorio', undefined, 'state');
    }

    return true;
  })
  .test('municipality', 'Campo obbligatorio', (values) => {
    const valuesCasted = (values || {}) as unknown as ResearchPerson;

    if (
      !valuesCasted.isEvent &&
      !valuesCasted.isForeign &&
      !valuesCasted.municipality?.description &&
      (valuesCasted.surname || valuesCasted.name || valuesCasted.gender || valuesCasted.birthDate)
    ) {
      return new yup.ValidationError('Campo obbligatorio', undefined, 'municipality');
    }

    return true;
  });

interface AccordionFilterPersonProps {
  open?: boolean;
  setOpen: (value: boolean) => void;
  isChoiceList?: boolean;
}

const AccordionFilterPersonComponent = ({
  open,
  setOpen,
  isChoiceList,
}: AccordionFilterPersonProps): ReactElement => {
  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="filter-person-content"
          id="panel-filter-person-header"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography>Filtri di ricerca per persona</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormFilter isChoiceList={isChoiceList} />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionFilterPersonComponent.displayName = 'Practice Research - Filter Person component';

const AccordionFilterPerson = memo(AccordionFilterPersonComponent);

export default AccordionFilterPerson;
